module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "iconsCell"
  }, [(_vm.hasNotes) ? _c('div', [_c('NotesHover', {
    attrs: {
      "reservation": _vm.reservation
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.hasTransport) ? _c('div', {
    staticClass: "transport",
    attrs: {
      "tabindex": "0"
    },
    on: {
      "mouseenter": _vm.openPopover,
      "mouseleave": _vm.closePopover
    }
  }, [_c('i', {
    staticClass: "ico ico-vehicle mr-0 fs-large",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isPopoverVisible),
      expression: "isPopoverVisible"
    }],
    staticClass: "transport-popover",
    class: {
      above: _vm.isPopoverAbove
    }
  }, [(_vm.displayedTransfers.length) ? _c('div', _vm._l((_vm.displayedTransfers), function(transfer, idx) {
    return _c('div', {
      key: idx,
      staticClass: "transport-card"
    }, [_c('div', {
      staticClass: "transport-title"
    }, [_vm._v(_vm._s(_vm.transportDirectionStatus(transfer.transportDirection)) + ":")]), _vm._v(" "), _c('div', {
      staticClass: "transport-body"
    }, [_c('div', {
      staticClass: "transport-time"
    }, [_vm._v(_vm._s(transfer.schedule.timeShort))]), _vm._v(" "), _c('div', {
      staticClass: "transport-location"
    }, [_vm._v(_vm._s(_vm.transferRouteText(transfer)))])])])
  }), 0) : _vm._e()])]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-7568b944", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7568b944"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservations/reservationLists/columns/icons.vue
// module id = 2776
// module chunks = 0